var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgUploadFile(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17.2072 9.2905C17.5977 9.68103 17.5977 10.3142 17.2072 10.7047C16.8167 11.0952 16.1835 11.0952 15.793 10.7047L13.002 7.91377V15C13.002 15.5523 12.5543 16 12.002 16C11.4498 16 11.002 15.5523 11.002 15V7.91368L8.20906 10.7067C7.81854 11.0972 7.18537 11.0972 6.79485 10.7067C6.40432 10.3161 6.40432 9.68298 6.79485 9.29245L11.2949 4.79241C11.4824 4.60487 11.7368 4.49951 12.002 4.49951C12.2672 4.49951 12.5216 4.60487 12.7091 4.79241L17.2072 9.2905Z",
    fill: "#6F767E"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4 14C4.55228 14 5 14.4477 5 15V17C5 17.5523 5.44772 18 6 18H18C18.5523 18 19 17.5523 19 17V15C19 14.4477 19.4477 14 20 14C20.5523 14 21 14.4477 21 15V17C21 18.6569 19.6569 20 18 20H6C4.34315 20 3 18.6569 3 17V15C3 14.4477 3.44772 14 4 14Z",
    fill: "#6F767E"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUploadFile);
export default __webpack_public_path__ + "static/media/upload_file.4260d2a4ff66649e383c20635c7be34d.svg";
export { ForwardRef as ReactComponent };